// Libs
import React, { useEffect, useState } from 'react';

// Components
import { Heading1, ToolButton } from '@ibinder/common-frontend';
import { menuBars } from '@ibinder/common-icons';
import { Heading3 } from '@ibinder/common-frontend';
import { useTranslation } from 'react-i18next';

// Styles
import {
  Wrapper,
  PageHeaderHeight,
  Header,
  AlignToTop,
  BinderInformationContent,
  Logo,
  Data,
  Head,
  Bread,
  BinderVerboseDescription,
  StyledButton
} from './binderInformation.styles';

const BinderInformation = ({
  binderInformation,
  loading,
  toggleTabsMenu,
  isBinderPanelOpen
}) => {
  const [internalBinderInfo, setInternalBinderInfo] = useState(
    binderInformation
      ? binderInformation
      : {
          name: '',
          type: '',
          description: '',
          iconPath: '',
          createdDate: '',
          toggleTabsMenu,
          isBinderPanelOpen,
          location: { address: '' }
        }
  );

  const { t } = useTranslation();
  const { name, type, description, iconPath, createdDate, location } =
    internalBinderInfo;

  useEffect(() => {
    if (binderInformation) {
      setInternalBinderInfo(binderInformation);
    }
  }, [binderInformation]);

  return (
    <Wrapper>
      <PageHeaderHeight>
        <Header>
          <Heading1 loading={loading} label={name} />

          <AlignToTop>
            {!loading && (
              <ToolButton
                type="button"
                active={isBinderPanelOpen}
                onClick={toggleTabsMenu}
              >
                {menuBars}
              </ToolButton>
            )}
          </AlignToTop>
        </Header>
      </PageHeaderHeight>
      <BinderInformationContent>
        <Heading3 loading={loading} label={'Welcome to SuperAdmin'} />
      </BinderInformationContent>
    </Wrapper>
  );
};

export default BinderInformation;
